import { render, staticRenderFns } from "./SectionsSettings.vue?vue&type=template&id=93e9d6b2"
import script from "./SectionsSettings.vue?vue&type=script&lang=js"
export * from "./SectionsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports